import { observable, makeObservable } from "mobx";
import {
  PageViews,
  UserStatus,
  FormData,
  VehicleIdType,
  VehicleInfo,
  Notification,
  NotificationTypes
} from "../models/NewExistingOwner";
import * as Request from "superagent";
import uniqId from "uniqid";

export default class NewExistingOwnerStore {
  //App
  @observable activePage: PageViews = PageViews.Intro;
  @observable isLoading: boolean = false;
  @observable notifications: Notification[] = [];

  //Opts
  userStatus: UserStatus = null;
  enableInvalidFormSubmit: boolean = false; //Only being used for Dev

  //Vehicle
  @observable registration: string = "";
  @observable vin: string = "";
  @observable modelName: string = null;
  @observable year: number = null;
  @observable variant: string = null;
  @observable warrantyEligible: boolean = false;

  //Details
  @observable email: string = "";
  @observable phone: string = "";
  @observable postcode: string = "";

  //General
  innerWidthClassNames: string = "col-xs-12 col-md-10 col-lg-8 col-md-offset-1 col-lg-offset-2";

  //Testing Data
  useSampleCarLookup: boolean = false;
  useSampleFormData: boolean = false;
  sampleFormData: FormData = {
    commsPhone: true,
    commsEmail: false,
    commsSms: false,
    commsPost: false,
    firstName: "John",
    lastName: "Smith",
    phone: "0411222333",
    email: "",
    dob: "",
    streetAddress: "449 Punt Rd",
    postcode: "",
    suburb: "",
    state: "",
    purchaseDate: "",
    optPrivacy: true,
    optMotoringClub: false,
    optSurvey: false,
    roadsideAssist: false
  };
  sampleCarLookupData: any = {
    modelName: "IMPREZA",
    variant: "2.0R",
    vin: "JF1GD9KE56G048583",
    registration: "ABC123",
    year: "2006",
    warrantyEligible: true
  };

  constructor() {
    makeObservable(this);
    // Dev Overrides
    // this.modelName = "XV";
    // this.userStatus = UserStatus.New;
    // this.activePage = PageViews.Details;
    // this.warrantyEligible = true;
    // // this.enableInvalidFormSubmit = true;
    // // this.isLoading = true;
    // this.registration = "AXI08F";
    // this.vin = "JF1GD9KE56G048587";
    // this.useSampleFormData = true;
    // this.sampleCarLookupData = {};
    // this.useSampleCarLookup = true;
  }

  fetchVehicleInfo(
    id: VehicleIdType,
    value: string,
    callback: Function,
    errorCallback: Function = () => {},
    retries: number = 2
  ): void {
    let attempts: number = 0;

    let url = "proxy/api/vlookup";
    this.isLoading = true;

    if (id === VehicleIdType.Registration) {
      url = `${url}/rego/${value}`;
      this.registration = value;
    } else {
      url = `${url}/vin/${value}`;
    }

    if (this.useSampleCarLookup) {
      this.isLoading = false;
      return callback.call(this, this.sampleCarLookupData);
    }

    const attempt = () => {
      attempts++;

      Request.get(url).then(
        res => {
          const response: VehicleInfo = res.body;
          this.isLoading = false;
          callback.call(this, response);
        },
        error => {
          if (attempts <= retries + 1) {
            console.log(error);
            console.log(`Fail(${attempts}). Retrying.`);
            attempt();
          } else {
            this.isLoading = false;
            this.addNotification({ type: NotificationTypes.Error, text: "An error occurred. Please try again." });
            errorCallback.call(this, {});
          }
        }
      );
    };

    attempt();
  }

  submitFormData(data: FormData) {
    this.isLoading = true;
    const url = "proxy/api/newowner";
    const payload = JSON.parse(JSON.stringify(data));
    delete payload["invalidFields"];
    delete payload["trigger"];
    payload.vin = this.vin;
    payload.registration = this.registration;
    payload.isChangeOfOwner = !(this.userStatus === UserStatus.Existing);
    payload.modelName = this.modelName;
    payload.modelYear = this.year;
    payload.badge = this.variant;

    Request.post(url)
      .set("Content-Type", "application/x-www-form-urlencoded")
      .send(payload)
      .then(
        res => {
          this.isLoading = false;
          this.activePage = PageViews.Thanks;
          this.email = payload.email;
          this.phone = payload.phone;
          this.postcode = payload.postcode;
        },
        error => {
          console.log(error);
          this.isLoading = false;
          this.addNotification({ type: NotificationTypes.Error, text: "An error occurred. Please try again." });
        }
      );
  }

  addNotification(notification: Notification) {
    const id: string = uniqId();
    this.notifications.push({ id, ...notification });
  }

  removeNotification(id: string) {
    const index = this.notifications.findIndex(i => i.id === id);
    this.notifications.splice(index, 1);
  }
}
